import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'

const NoScheduledDriveAlert = () => {
  const { t } = useTranslation('navigation')

  return (
    <AlertContainer
      type="alert"
      alertText={t('noScheduledDrive')}
      alertColor="teal"
      position="bottom"
      opacity="low"
      noOverlay
      height="small"
    />
  )
}

export default NoScheduledDriveAlert
